import React from "react";
import Logo from "../../layouts/logo";
import { FaSearch } from "react-icons/fa";
import Input from 'components/ui/input.jsx'
import Search from 'components/ui/search/search.tsx'
import { Link } from "react-router-dom";

import {Links} from '../../routes/PathLink'
import { BiTrendingUp } from "react-icons/bi";
import {
  useIndicesCompaniesQuery,
} from 'data/indices-details';
import { useSiteSettings } from '../../contexts/site-settings/site-settings';
import {APP_URL, APP_NAME, cleanCompanyName} from 'components/config/Common'

export default function SearchHome() {
  
  const { sitelogo } = useSiteSettings();
  const {
    product: companies
    } = useIndicesCompaniesQuery({ 
      id: '2217',//Nifty 50
      limit: 10,
    });

    //console.log("product companies", companies);

  return (
    <div className="py-20 bg-slate-100 flex flex-col items-center justify-center px-4">
      {/* Logo */}
      
      <div className="flex items-center gap-3 mb-4 justify-center">
        <span className="flex relative overflow-hidden items-center">
                {sitelogo ?
                ( <img src={`${process.env.REACT_APP_IMG_URL+sitelogo}`} alt={`${APP_NAME} Logo`}  />)
                :
                ( <h1 className='text-3xl'>{APP_NAME}</h1>)
                }
              </span>
      </div>

      {/* Subtitle */}
      <p className="text-gray-600 mb-12 text-center">
        Smart analysis for smart decisions.
      </p>

      {/* Search box */}      
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-sm border p-6 mb-8">
        <div className="relative">
        <Search
            placeholder="Search stocks, symbols"
            variant={'minimal'}
        />
        </div>
        {/* <div className="flex items-center justify-between mt-4 text-sm text-gray-500">
          <span>Examples:</span>
          <div className="flex gap-3 flex-wrap justify-end">
          <span className="hover:text-accent cursor-pointer">TCS</span>
          <span className="hover:text-accent cursor-pointer">INFY</span>
          <span className="hover:text-accent cursor-pointer">RELIANCE</span>
          </div>
        </div> */}
      </div>

      {/* Analyse section */}
      {/* <div className="mb-3 text-gray-600 text-sm">Quick analyse</div> */}

      <div className="flex flex-wrap justify-center gap-2 lg:gap-3 max-w-3xl pt-5">
        {companies?.map((company, index) => (
          <Link
            to={`${Links.COMPANY}/${company.symbol}`}
            key={index}
            className="px-3 py-2 text-sm bg-white border border-gray-200 text-gray-700 rounded-full hover:border-accent hover:text-accent hover:shadow transition"
          >
            {cleanCompanyName(company.company_name)}
          </Link>
        ))}
      </div>
    </div>
  );
}
